import React from "react";
import {
  LIBRARY,
  ANNOUNCEMENT,
  PUBLIC_OVERVIEW,
  PUBLIC_DAF,
  APPROVEDPRODUCTS,
  GETTING_STARTED,
  //PUBLIC_VSTT,
} from "./PageRoutes";

export const TOP_NAV_ROUTES = [
  {
    menuLabel: "Learn",
    key: "learnMenu",
    isPublic: true,
    children: [
      {
        menuLabel: "Visa Secure Overview",
        key: "learnVisaSecureMenu",
        redirect: PUBLIC_OVERVIEW,
        isPublic: true,
      },
      // {
      //   menuLabel: "Visa Secure Test Tools",
      //   key: "learnVSTT",
      //   redirect: PUBLIC_VSTT,
      //   isPublic: true,
      // },
      // {
      //   menuLabel: "DAF",
      //   key: "learnDafMenu",
      //   redirect: PUBLIC_DAF,
      //   isPublic: true,
      // },
    ],
  },
  {
    menuLabel: "Engage",
    key: "engageMenu",
    isPublic: true,
    children: [
      {
        menuLabel: "Getting Started",
        key: "engageGettingStartedMenu",
        redirect: GETTING_STARTED,
        isPublic: true,
      },
    ],
  },
  {
    menuLabel: "Partners",
    key: "partnersMenu",
    isPublic: true,
    children: [
      {
        menuLabel: "Approved Products",
        key: "approvedProductsMenu",
        redirect: APPROVEDPRODUCTS.APPROVED_PRODUCTS_PUBLIC,
        isPublic: true,
      },
      {
        menuLabel: (
          <span>Approved Products – <span style={{ color: "red" }}>INTERNAL</span>
          </span>),
        key: "approvedProductsStaffMenu",
        redirect: APPROVEDPRODUCTS.APPROVED_PRODUCTS_ALL,
        isPublic: false,
      }
    ],
  },
  {
    menuLabel: "Admin",
    key: "adminManagementMenu",
    redirect: ANNOUNCEMENT,
    isPublic: false,
    adminMenu: true,
  },
  {
    menuLabel: (<span>VSS Library</span>),
    menuIcon: (
      <img
        className="vss-library-image"
        src="images/library.png"
        alt="VSS Library"
      />
    ),
    key: "vssLibraryMenu",
    redirect: LIBRARY,
    isPublic: true,
    alwaysVisible: true
  },
];
